import React from "react";


import Abouthero from "../components/Abouthero";
import Fact from "../components/WhyChooseUs";
import Services from "../components/ServicesSection";
import Faqs from "../components/Faqs";
import WhyUs from "../components/WhyUsSection";
import CTAPage from "../components/CTAPage";
import ContactUs from "../components/ContactSection";

const AboutPage = ({ isDarkMode }) => {
  const facts = [
    "Our team has over 20 years of combined experience.",
    "We’ve completed 100+ successful projects across various industries.",
    "We are committed to providing sustainable tech solutions.",
  ];

  return (
    <>
       <Abouthero isDarkMode={isDarkMode} />

      <Fact isDarkMode={isDarkMode} facts={facts} />
      <Services isDarkMode={isDarkMode} />
      <Faqs isDarkMode={isDarkMode} />
      <WhyUs isDarkMode={isDarkMode} />
      <CTAPage isDarkMode={isDarkMode} />
      <ContactUs isDarkMode={isDarkMode} />
    </>
  );
};

export default AboutPage;